import React from "react";
import NiceModal from "@ebay/nice-modal-react";
import {Box, Chip} from "@bounce/shared/ui";
import {CARD_PAYMENTS_RETRY_FLOW_TYPE, CardPaymentsRetryPolicy} from "../../../apis/requests/payment-flows/types";
import PaymentFlowsList from "../PaymentFlowsList";
import {getPolicySummary} from "./helpers";
import RetryTestDialog from "./RetryTestDialog";

const DELETE_COPY = {
  title: "Delete retry test",
  warning:
    "Card payments that currently match this test will fall through to the next matching test, usually the default.",
};

const EDITOR = {
  addLabel: "+ Add retry test",
  open: (flowId?: number) => NiceModal.show(RetryTestDialog, {flowId}),
};

const RetryPolicySummary = (policy: CardPaymentsRetryPolicy) => (
  <Box sx={{display: "flex", flexWrap: "wrap", alignItems: "center", gap: 0.75}}>
    {getPolicySummary(policy).map((item) => (
      <Chip key={item} size_="small" variant_="inherit" label={item} />
    ))}
  </Box>
);

const CardPaymentsRetryPage = () => (
  <PaymentFlowsList
    type={CARD_PAYMENTS_RETRY_FLOW_TYPE}
    title="Card payments retry"
    noRowsText="No retry tests yet"
    loadErrorText="Failed to load retry tests."
    deleteCopy={DELETE_COPY}
    renderPolicy={RetryPolicySummary}
    editor={EDITOR}
  />
);

export default CardPaymentsRetryPage;
